import { useEffect, useState } from "react";
// import { toast } from 'react-toastify';
import toast from "react-hot-toast";
import Form from "react-bootstrap/Form";
import axios from "axios";


const API_KEY = process.env.REACT_APP_API_URL

export function CreateAppForm() {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    link: "",
    category_id: "",
    introduction: "",
    added_on: "",
    monthly_visitors: "",
    social_tags: [],
    tags_csv: "",
    faqs: [{ question: "", answer: "" }],
    pricing: [{ plan: "", price: "", priceDescription: "" }],
    question_info: { description: "" },
    how_to_use: { description: "" },
    company_logo: "",
    company_image: "",
    core_features: [],
    use_cases: [],
    contact_url: "",
    company_name: "",
    company_address: "",
    company_email: "",
    signup_url: "",
    login_url: "",
    about_url: "",
    company_price: "",
    company_facebook: "",
    company_linkedin: "",
    company_twitter: "",
    company_instagram: "",
    isFeatures: false,
  });

  const [newFeature, setNewFeature] = useState("");
  const [newUseCase, setNewUseCase] = useState("");
  const [newTag, setNewTag] = useState("");

  const [categories, setCategories] = useState([]);
  const [companyLogoFile, setCompanyLogoFile] = useState(null);
  const [companyImageFile, setCompanyImageFile] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${API_KEY}/api/categories`);
        setCategories(res?.data?.categories);
      } catch (err) {
        console.error("Error fetching apps:", err.message);
      }
    };

    fetchCategories();
  }, []);

  const handleFaqChange = (index, field, value) => {
    const updatedFaqs = [...formData.faqs];
    updatedFaqs[index][field] = value;
    setFormData({ ...formData, faqs: updatedFaqs });
  };

  const handlePriceChange = (index, field, value) => {
    const updatedPricing = [...formData.pricing];
    updatedPricing[index][field] = value;
    setFormData({ ...formData, pricing: updatedPricing });
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];

    setCompanyLogoFile(file);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];

    setCompanyImageFile(file);
  };

  const addFaq = () => {
    setFormData({
      ...formData,
      faqs: [...formData.faqs, { question: "", answer: "" }],
    });
  };

  const addPricing = () => {
    setFormData({
      ...formData,
      pricing: [
        ...formData.pricing,
        { plan: "", price: "", priceDescription: "" },
      ],
    });
  };

  const addCoreFeature = () => {
    if (newFeature.trim()) {
      setFormData({
        ...formData,
        core_features: [...formData.core_features, newFeature.trim()],
      });
      setNewFeature("");
    }
  };

  const removeCoreFeature = (index) => {
    const updated = formData.core_features.filter((_, i) => i !== index);
    setFormData({ ...formData, core_features: updated });
  };

  const addUseCase = () => {
    if (newUseCase.trim()) {
      setFormData({
        ...formData,
        use_cases: [...formData.use_cases, newUseCase.trim()],
      });
      setNewUseCase("");
    }
  };

  const removeUseCase = (index) => {
    const updated = formData.use_cases.filter((_, i) => i !== index);
    setFormData({ ...formData, use_cases: updated });
  };

  const addSocialTag = () => {
    if (newTag.trim()) {
      setFormData({
        ...formData,
        social_tags: [...formData.social_tags, newTag.trim()],
      });
      setNewTag("");
    }
  };

  const removeSocialTag = (index) => {
    const updated = formData.social_tags.filter((_, i) => i !== index);
    setFormData({ ...formData, social_tags: updated });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData();

    if (!companyLogoFile || !companyImageFile) {
      toast.error("Please select both company logo and company image.");
      return;
    }

    const payload = {
      ...formData,
      monthly_visitors: Number(formData.monthly_visitors),
    };

    for (const key in payload) {
      const value = payload[key];
      if (Array.isArray(value) && key !== "faqs" && key !== "pricing") {
        value.forEach((item) => form.append(`${key}[]`, item));
      } else if (
        typeof value === "object" &&
        value !== null &&
        key !== "faqs" &&
        key !== "pricing"
      ) {
        form.append(key, JSON.stringify(value));
      } else if (key !== "faqs" && key !== "pricing") {
        form.append(key, value ?? "");
      }
    }

    // Handle FAQs
    formData.faqs.forEach((faq, i) => {
      form.append(`faqs[${i}][question]`, faq.question);
      form.append(`faqs[${i}][answer]`, faq.answer);
    });

    // ✅ Handle Pricing
    formData.pricing.forEach((item, i) => {
      form.append(`pricing[${i}][plan]`, item.plan);
      form.append(`pricing[${i}][price]`, item.price);
      form.append(`pricing[${i}][priceDescription]`, item.priceDescription);
    });

    // Add files
    if (companyLogoFile) form.append("company_logo", companyLogoFile);
    if (companyImageFile) form.append("company_image", companyImageFile);


    try {
      const response = await fetch(`${API_KEY}/api/apps/`, {
        method: "POST",
        body: form,
      });

      const result = await response.json();
 

      setFormData((prev) => ({
        ...prev,
        company_logo: result.app.company_logo,
        company_image: result.app.company_image,
      }));
      // setCompanyLogoFile(null);
      // setCompanyImageFile(null);

      toast.success("App submitted successfully!");

      setFormData({
        name: "",
        description: "",
        link: "",
        category_id: "",
        introduction: "",
        added_on: "",
        monthly_visitors: "",
        social_tags: [],
        tags_csv: "",
        faqs: [{ question: "", answer: "" }],
        pricing: [{ plan: "", price: "", priceDescription: "" }],
        question_info: { description: "" },
        how_to_use: { description: "" },
        core_features: [],
        use_cases: [],
        contact_url: "",
        company_name: "",
        company_address: "",
        company_email: "",
        signup_url: "",
        login_url: "",
        about_url: "",
        company_logo: "",
        company_price: "",
        company_facebook: "",
        company_linkedin: "",
        company_twitter: "",
        company_instagram: "",
        // isFeatures: false,
      });
      setCompanyLogoFile(null);
      setCompanyImageFile(null);
    } catch (err) {
      console.error("Error:", err.message);
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="card border-0 shadow-lg">
            <div className="card-header bg-primary text-white py-3">
              <h4 className="mb-0 text-center">SUBMIT YOUR APPLICATION</h4>
            </div>
            <div className="card-body p-4">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* Left Column */}
                  <div className="col-md-6 pe-md-4">
                    {/* Basic Information Section */}
                    <div className="mb-4">
                      <h5 className="text-primary mb-3 border-bottom pb-2">
                        Basic Information
                      </h5>
                      {[
                        { label: "App Name", name: "name", required: true },
                        {
                          label: "Description",
                          name: "description",
                          type: "textarea",
                        },
                        { label: "Link", name: "link", type: "url" },
                        {
                          label: "Introduction",
                          name: "introduction",
                          type: "textarea",
                        },
                        { label: "Added On", name: "added_on", type: "date" },
                        {
                          label: "Monthly Visitors",
                          name: "monthly_visitors",
                          type: "number",
                        },
                      ].map(
                        ({ label, name, type = "text", required = false }) => (
                          <div className="mb-3" key={name}>
                            <label className="form-label fw-semibold">
                              {label}{" "}
                              {required && (
                                <span className="text-danger">*</span>
                              )}
                            </label>
                            {type === "textarea" ? (
                              <textarea
                                className="form-control"
                                rows={3}
                                value={formData[name]}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    [name]: e.target.value,
                                  })
                                }
                                required={required}
                              />
                            ) : (
                              <input
                                type={type}
                                className="form-control"
                                value={formData[name]}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    [name]: e.target.value,
                                  })
                                }
                                required={required}
                              />
                            )}
                          </div>
                        )
                      )}
                    </div>

                    {/* Company Information Section */}
                    <div className="mb-4">
                      <h5 className="text-primary mb-3 border-bottom pb-2">
                        Company Information
                      </h5>
                      {[
                        { label: "Company Name", name: "company_name" },
                        { label: "Company Price", name: "company_price" },
                        { label: "Company Address", name: "company_address" },
                        { label: "Company Email", name: "company_email" },
                      ].map(({ label, name }) => (
                        <div className="mb-3" key={name}>
                          <label className="form-label fw-semibold">
                            {label}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData[name]}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                [name]: e.target.value,
                              })
                            }
                          />
                        </div>
                      ))}
                    </div>

                    {/* Social Media Section */}
                    <div className="mb-4">
                      <h5 className="text-primary mb-3 border-bottom pb-2">
                        Social Media
                      </h5>
                      {[
                        {
                          label: "Facebook",
                          name: "company_facebook",
                          icon: "fa-facebook",
                        },
                        {
                          label: "LinkedIn",
                          name: "company_linkedin",
                          icon: "fa-linkedin",
                        },
                        {
                          label: "Twitter",
                          name: "company_twitter",
                          icon: "fa-twitter",
                        },
                        {
                          label: "Instagram",
                          name: "company_instagram",
                          icon: "fa-instagram",
                        },
                      ].map(({ label, name, icon }) => (
                        <div className="mb-3" key={name}>
                          <label className="form-label fw-semibold">
                            <i className={`fab ${icon} me-2 text-primary`}></i>
                            {label}
                          </label>
                          <div className="input-group">
                            <span className="input-group-text">https://</span>
                            <input
                              type="text"
                              className="form-control"
                              value={formData[name]}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  [name]: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="col-md-6 ps-md-4">
                    {/* Category & URLs Section */}
                    <div className="mb-4">
                      <h5 className="text-primary mb-3 border-bottom pb-2">
                        Category & URLs
                      </h5>
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Category
                        </label>
                        <select
                          className="form-select"
                          value={formData.category_id}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              category_id: e.target.value,
                            })
                          }
                        >
                          <option value="">Select a category</option>
                          {categories.map((cat) => (
                            <option key={cat._id} value={cat._id}>
                              {cat.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      {[
                        { label: "Signup URL", name: "signup_url" },
                        { label: "Login URL", name: "login_url" },
                        { label: "About URL", name: "about_url" },
                        { label: "Contact Info", name: "contact_url" },
                      ].map(({ label, name }) => (
                        <div className="mb-3" key={name}>
                          <label className="form-label fw-semibold">
                            {label}
                          </label>
                          <input
                            type="url"
                            className="form-control"
                            value={formData[name]}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                [name]: e.target.value,
                              })
                            }
                          />
                        </div>
                      ))}
                    </div>

                    {/* Media Uploads Section */}
                    <div className="mb-4">
                      <h5 className="text-primary mb-3 border-bottom pb-2">
                        Media Uploads
                      </h5>

                      {/* Company Logo */}
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Company Logo
                        </label>

                        {!companyLogoFile && !formData.company_logo ? (
                          <div className="border rounded p-3 text-center">
                            <input
                              type="file"
                              className="d-none"
                              id="logo-upload"
                              accept="image/*"
                              onChange={handleLogoUpload}
                            />
                            <label
                              htmlFor="logo-upload"
                              className="btn btn-outline-primary w-100"
                            >
                              <i className="fas fa-upload me-2"></i>Upload Logo
                            </label>
                            <small className="text-muted d-block mt-2">
                              Recommended size: 300x300px
                            </small>
                          </div>
                        ) : (
                          <div className="d-flex align-items-center gap-3">
                            <div className="position-relative">
                              <img
                                src={
                                  companyLogoFile
                                    ? URL.createObjectURL(companyLogoFile)
                                    : `${API_KEY}/temp/${formData.company_logo}`
                                }
                                alt="Logo Preview"
                                className="img-thumbnail"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "contain",
                                }}
                              />
                              <button
                                type="button"
                                className="btn btn-danger btn-sm position-absolute top-0 end-0 rounded-circle"
                                style={{ transform: "translate(50%, -50%)" }}
                                onClick={() => {
                                  setCompanyLogoFile(null);
                                  setFormData((prev) => ({
                                    ...prev,
                                    company_logo: "",
                                  }));
                                }}
                              >
                                <i className="fas fa-times"></i>
                              </button>
                            </div>
                            <div>
                              <p className="mb-1">
                                {companyLogoFile
                                  ? companyLogoFile.name
                                  : formData.company_logo}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Company Image */}
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Company Image
                        </label>
                        {!companyImageFile && !formData.company_image ? (
                          <div className="border rounded p-3 text-center">
                            <input
                              type="file"
                              className="d-none"
                              id="image-upload"
                              accept="image/*"
                              onChange={handleImageUpload}
                            />
                            <label
                              htmlFor="image-upload"
                              className="btn btn-outline-primary w-100"
                            >
                              <i className="fas fa-upload me-2"></i>Upload Image
                            </label>
                            <small className="text-muted d-block mt-2">
                              Recommended size: 1200x630px
                            </small>
                          </div>
                        ) : (
                          <div className="d-flex align-items-center gap-3">
                            <div className="position-relative">
                              <img
                                src={
                                  companyImageFile
                                    ? URL.createObjectURL(companyImageFile)
                                    : `${API_KEY}/temp/${formData.company_image}`
                                }
                                alt="Image Preview"
                                className="img-thumbnail"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "cover",
                                }}
                              />
                              <button
                                type="button"
                                className="btn btn-danger btn-sm position-absolute top-0 end-0 rounded-circle"
                                style={{ transform: "translate(50%, -50%)" }}
                                onClick={() => {
                                  setCompanyImageFile(null);
                                  setFormData((prev) => ({
                                    ...prev,
                                    company_image: "",
                                  }));
                                }}
                              >
                                <i className="fas fa-times"></i>
                              </button>
                            </div>
                            <div>
                              <p className="mb-1">
                                {companyImageFile
                                  ? companyImageFile.name
                                  : formData.company_image}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Tags Section */}
                    <div className="mb-4">
                      <h5 className="text-primary mb-3 border-bottom pb-2">
                        Tags
                      </h5>
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Tags CSV (comma separated)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.tags_csv}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              tags_csv: e.target.value,
                            })
                          }
                          placeholder="tag1, tag2, tag3"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Social Tags
                        </label>
                        <div className="d-flex gap-2 mb-2">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter social tag"
                            value={newTag}
                            onChange={(e) => setNewTag(e.target.value)}
                          />
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={addSocialTag}
                          >
                            <i className="fas fa-plus"></i>
                          </button>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                          {formData.social_tags.map((tag, idx) => (
                            <span
                              key={idx}
                              className="badge bg-primary bg-opacity-10 text-primary d-flex align-items-center"
                            >
                              {tag}
                              <button
                                type="button"
                                className="btn-close btn-close-primary btn-sm ms-2"
                                style={{ fontSize: "0.5rem" }}
                                onClick={() => removeSocialTag(idx)}
                              ></button>
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Full Width Sections */}
                <div className="row">
                  <div className="col-12">
                    {/* Features Section */}
                    <div className="mb-4">
                      <h5 className="text-primary mb-3 border-bottom pb-2">
                        Features
                      </h5>
                      <div className="mb-3 form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="featuresToggle"
                          checked={formData.isFeatures}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              isFeatures: e.target.checked,
                            })
                          }
                        />
                        <label
                          className="form-check-label fw-semibold"
                          htmlFor="featuresToggle"
                        >
                          Enable Features Section
                        </label>
                      </div>

                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Core Features
                        </label>
                        <div className="d-flex gap-2 mb-2">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="New feature"
                            value={newFeature}
                            onChange={(e) => setNewFeature(e.target.value)}
                          />
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={addCoreFeature}
                          >
                            <i className="fas fa-plus me-1"></i> Add
                          </button>
                        </div>
                        <div className="list-group">
                          {formData.core_features.map((feature, idx) => (
                            <div
                              key={idx}
                              className="list-group-item d-flex justify-content-between align-items-center"
                            >
                              <span>{feature}</span>
                              <button
                                type="button"
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => removeCoreFeature(idx)}
                              >
                                <i className="fas fa-trash-alt"></i>
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* Use Cases Section */}
                    <div className="mb-4">
                      <h5 className="text-primary mb-3 border-bottom pb-2">
                        Use Cases
                      </h5>
                      <div className="d-flex gap-2 mb-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="New use case"
                          value={newUseCase}
                          onChange={(e) => setNewUseCase(e.target.value)}
                        />
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={addUseCase}
                        >
                          <i className="fas fa-plus me-1"></i> Add
                        </button>
                      </div>
                      <div className="list-group">
                        {formData.use_cases.map((usecase, idx) => (
                          <div
                            key={idx}
                            className="list-group-item d-flex justify-content-between align-items-center"
                          >
                            <span>{usecase}</span>
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm"
                              onClick={() => removeUseCase(idx)}
                            >
                              <i className="fas fa-trash-alt"></i>
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* FAQ Section */}
                    <div className="mb-4">
                      <h5 className="text-primary mb-3 border-bottom pb-2">
                        FAQs
                      </h5>
                      {formData.faqs.map((faq, idx) => (
                        <div
                          key={idx}
                          className="mb-3 border rounded p-3 bg-light"
                        >
                          <div className="mb-2">
                            <label className="form-label fw-semibold">
                              Question {idx + 1}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={faq.question}
                              onChange={(e) =>
                                handleFaqChange(idx, "question", e.target.value)
                              }
                              required
                            />
                          </div>
                          <div>
                            <label className="form-label fw-semibold">
                              Answer
                            </label>
                            <textarea
                              className="form-control"
                              rows={3}
                              value={faq.answer}
                              onChange={(e) =>
                                handleFaqChange(idx, "answer", e.target.value)
                              }
                              required
                            />
                          </div>
                          <div className="text-end mt-2">
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm"
                              onClick={() => {
                                const newFaqs = [...formData.faqs];
                                newFaqs.splice(idx, 1);
                                setFormData({ ...formData, faqs: newFaqs });
                              }}
                            >
                              <i className="fas fa-trash me-1"></i> Remove FAQ
                            </button>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={addFaq}
                      >
                        <i className="fas fa-plus me-1"></i> Add FAQ
                      </button>
                    </div>

                    {/* Pricing Section */}
                    <div className="mb-4">
                      <h5 className="text-primary mb-3 border-bottom pb-2">
                        Pricing
                      </h5>
                      {formData.pricing.map((price, idx) => (
                        <div
                          key={idx}
                          className="mb-3 border rounded p-3 bg-light"
                        >
                          <div className="row">
                            <div className="col-md-4 mb-2">
                              <label className="form-label fw-semibold">
                                Plan Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={price.plan}
                                onChange={(e) =>
                                  handlePriceChange(idx, "plan", e.target.value)
                                }
                                required
                              />
                            </div>
                            <div className="col-md-4 mb-2">
                              <label className="form-label fw-semibold">
                                Price
                              </label>
                              <div className="input-group">
                                <span className="input-group-text">$</span>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={price.price}
                                  onChange={(e) =>
                                    handlePriceChange(
                                      idx,
                                      "price",
                                      e.target.value
                                    )
                                  }
                                  required
                                />
                              </div>
                            </div>
                            <div className="col-md-12 mt-2">
                              <label className="form-label fw-semibold">
                                Description
                              </label>
                              <textarea
                                className="form-control"
                                rows={2}
                                value={price.priceDescription}
                                onChange={(e) =>
                                  handlePriceChange(
                                    idx,
                                    "priceDescription",
                                    e.target.value
                                  )
                                }
                                required
                              />
                            </div>
                          </div>
                          <div className="text-end mt-2">
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm"
                              onClick={() => {
                                const newPricing = [...formData.pricing];
                                newPricing.splice(idx, 1);
                                setFormData({
                                  ...formData,
                                  pricing: newPricing,
                                });
                              }}
                            >
                              <i className="fas fa-trash me-1"></i> Remove Plan
                            </button>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={addPricing}
                      >
                        <i className="fas fa-plus me-1"></i> Add Pricing Plan
                      </button>
                    </div>

                    {/* Additional Info Sections */}
                    <div className="row">
                      <div className="col-md-6 mb-4">
                        <h5 className="text-primary mb-3 border-bottom pb-2">
                          Question Info
                        </h5>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            Description
                          </label>
                          <textarea
                            className="form-control"
                            rows={4}
                            value={formData?.question_info?.description}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                question_info: { description: e.target.value },
                              })
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-6 mb-4">
                        <h5 className="text-primary mb-3 border-bottom pb-2">
                          How to Use
                        </h5>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">
                            Description
                          </label>
                          <textarea
                            className="form-control"
                            rows={4}
                            value={formData.how_to_use.description}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                how_to_use: { description: e.target.value },
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="text-center mt-4">
                  <button type="submit" className="btn btn-primary btn-lg px-5">
                    <i className="fas fa-paper-plane me-2"></i> Submit
                    Application
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
